module.exports = function() {
  return new Worker(__webpack_public_path__ + "43d01c8d3740dca4648a.worker.js");
};